import { createAction, createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';

const INITIAL_STATE = Immutable({
  posts: [],
  totalCount: 0,
  currentPost: null,
  socialPostsLoading: false,
});

export const loadSocialWallPostsAction = createAction('loadSocialWallPosts');
export const loadSocialWallPostsSuccessAction = createAction('loadSocialWallPostsSucceeded');
export const loadSocialWallPostsFailedAction = createAction('loadSocialWallPostsFailed');

export const loadMoreSocialWallPostsAction = createAction('loadMoreSocialWallPosts');
export const loadMoreSocialWallPostsSuccessAction = createAction('loadMoreSocialWallPostsSucceeded');
export const loadMoreSocialWallPostsFailedAction = createAction('loadMoreSocialWallPostsFailed');

export const createSocialWallPostAction = createAction('createSocialWallPostAction');
export const createSocialWallPostSuccessAction = createAction('createSocialWallPostSuccessAction');

export const removeImageForSocialPostAction = createAction('removeImageForSocialPostAciton');

export const createResponseAction = createAction('createResponseAction');
export const createResponseSuccessAction = createAction('createResponseSuccessAction');

export const loadSocialWallPostAction = createAction('loadSocialWallPostAction', 'socialPost');
export const loadSocialWallPostSuccessAction = createAction('loadSocialWallPostSuccessAction', 'socialPost');
export const loadSocialWallPostFailedAction = createAction('loadSocialWallPostFailedAction', 'socialPost');

export const updateSocialWallPostAction = createAction('updateSocialWallPostAction');
export const updateSocialWallPostSuccessAction = createAction('updateSocialWallPostSuccessAction');
export const updateSocialWallPostFailedAction = createAction('updateSocialWallPostFailedAction');

export const deleteSocialWallPostAction = createAction('delteSocialWallPostAction');
export const deleteSocialWallPostSuccessAction = createAction('delteSocialWallPostSuccessAction');
export const deleteSocialWallPostFailedAction = createAction('delteSocialWallPostFailedAction');


const reducers = createReducer({
  [loadSocialWallPostsAction]: state => state.merge({ socialPostsLoading: true }),
  [loadSocialWallPostsFailedAction]: state => state.merge({ socialPostsLoading: false }),
  [loadSocialWallPostsSuccessAction]: (state, postsDto) => state.merge({
    socialPostsLoading: false,
    posts: postsDto.posts,
    totalCount: postsDto.totalPostCount,
  }),
  [loadMoreSocialWallPostsAction]: state => state.merge({ socialPostsLoading: true }),
  [loadMoreSocialWallPostsFailedAction]: state => state.merge({ socialPostsLoading: false }),
  [loadMoreSocialWallPostsSuccessAction]: (state, postsDto) => {
    let posts = state.posts.asMutable();
    posts = posts.concat(postsDto.posts);
    return state.merge({
      posts,
      totalCount: postsDto.totalPostCount,
      socialPostsLoading: false,
    });
  },
  [loadSocialWallPostAction]: state => state.merge({ singlePostLoading: true }),
  [loadSocialWallPostSuccessAction]: (state, post) => state.merge({ singlePostLoading: false, currentPost: post }),
  [loadSocialWallPostFailedAction]: state => state.merge({ singlePostLoading: true }),
  [createSocialWallPostSuccessAction]: (state, post) => {
    const posts = state.posts.asMutable();
    posts.unshift(post);
    return state.merge({
      posts,
    });
  },

  [createResponseSuccessAction]: (state, { id, response }) => {
    const posts = state.posts.asMutable({ deep: true });
    const postToUpdate = posts.find(p => p.id === id);
    const index = posts.indexOf(postToUpdate);
    let responsesForPost = postToUpdate.responses;
    if (response.hasBeenRemoved) {
      const res = responsesForPost
          .find(p => p.userId === response.userId &&
            response.socialWallPostId === p.socialWallPostId &&
            response.responseType === 'Feedback');

      if (!res) return state;

      responsesForPost = responsesForPost
          .filter(p => p.id !== res.id);
    } else {
      responsesForPost.unshift(response);
    }

    postToUpdate.responses = responsesForPost;
    posts[index] = postToUpdate;
    return state.merge({
      posts,
    });
  },
  [deleteSocialWallPostSuccessAction]: (state, id) => state.merge({
    posts: state.posts.filter(p => p.id !== id),
  }),
}, INITIAL_STATE);

export default reducers;



// WEBPACK FOOTER //
// ./src/app/reducers/socialwall.reducers.js